import { render, staticRenderFns } from "./c-header.vue?vue&type=template&id=40da3b6f"
import script from "./c-header.vue?vue&type=script&lang=js"
export * from "./c-header.vue?vue&type=script&lang=js"
import style0 from "./c-header.vue?vue&type=style&index=0&id=40da3b6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports